import React, {useContext, useEffect, useState} from "react";
import {ViewMangementContext, RecordsManagementContext} from "../StatesMangement/InitialiseContext";
import axios from "axios";
import {
    CreateBedrooms,
    Elink,
    LastPageVisited
} from "../CommonComponents/Routes";
import {Modal} from "react-bootstrap";
import KeypadModal from "./KeypadModal";
import './secondPage.css'
import './Animation.css'
import {Animation} from "./Animation";
import {AnimationPrevious} from "./AnimationPrevious";
import {GetTextColor} from "./GetTextColor";

export default () => { // this is common component for adding number of bedrooms
    let PageView = useContext(ViewMangementContext);
    let RecordController = useContext(RecordsManagementContext);
    const [Keyboard, setKeyboard] = useState(false);
    const [ActiveButton, setActiveButton] = useState('');
    const [ShowKeyPad, setShowKeyPad] = useState(false);
    let JobIsOpen = RecordController.IsCustomerEditEstAftrBook
    let DefaultRoomName = RecordController.ML_Start.DefaultRoomsName.toString();
    let DefaultRoomId = RecordController.ML_Start.DefaultRoomsId[0];
    let CustomerInvReq = RecordController.ML_Start.CustomerInventoryRequest;

    useEffect(  async () => {
        if (RecordController.Click) {
            Animation("bedroom-page",RecordController.Click);
        }
        await RecordController.setAddManual(false);
        await ActiveNextButton(RecordController.OtherBedrooms);
        axios({ // update the customer's last visited
            method: 'post',
            url: LastPageVisited,
            params: {estimate_key: Elink, last_visited_page: 'SHOW_MOBILE_LINK_BEDROOM'}
        })
    }, []);

    const ShowSecondStep = (event) => { // works for skip and next button ( go to default room page or my home page )
        handleModal();
        let element = document.getElementsByClassName('bedroom-page');
        let last_visit_page = DefaultRoomId ? "SHOW_MOBILE_LINK_DEFAULT_ROOMS" : "SHOW_MOBILE_LINK_MY_ROOMS"
        last_visit_page = (RecordController.OtherBedrooms || event === 'skip') ? last_visit_page : 'SHOW_MOBILE_LINK_BEDROOM'
        ActiveButton === 'otherRooms' ? RecordController.setAddManual(true) : RecordController.setAddManual(false)
        ActiveButton === 'otherRooms' ? RecordController.setIsActive(false) : RecordController.setIsActive(true)
        if (ActiveButton === 'otherRooms') {
            for (let i = 0; i < element.length; i++) {
                element[i].classList.add('next')// add class for animation ( switch between different default rooms)
                if(element[i].classList.contains('back')){element[i].classList.remove('back')}
            }
            last_visit_page = RecordController.addManual || event === "skip" ? last_visit_page : "SHOW_MOBILE_LINK_BEDROOM"
        }
        if (event === 'next' && RecordController.OtherBedrooms > 0 && RecordController.OtherBedrooms < 21){
            ActiveNextButton(RecordController.OtherBedrooms)
            axios({//post request is send to the "add_bedrooms" for creating bedrooms if next button is click.
                method: 'post',
                url: CreateBedrooms,
                data: {
                    estimate_key: Elink,
                    bedrooms_count: RecordController.OtherBedrooms,
                    default_room_ids: RecordController.ML_Start.DefaultRoomsId,
                    last_visited_page: last_visit_page
                }
            })
        }
        RecordController.SetClick('next'); // add animation class
        AnimationPrevious ( "next-go",  "bedroom-page",  last_visit_page, PageView); // add animation for this page
        if(RecordController.OtherBedrooms) {
            RecordController.SetML_Start({
                ...RecordController.ML_Start,
                BedroomCount: RecordController.OtherBedrooms // updating BedroomCount
            });
        }
    }

    const BackStep = () => { // move to back ( to bedrooms page and switches between multiple default rooms )
        handleModal();
        let element = document.getElementsByClassName('bedroom-page');
        let last_visit_page = RecordController.addManual ? "SHOW_MOBILE_LINK_BEDROOM" : "SHOW_MOBILE_LINK"
        if (ActiveButton === 'otherRooms') {
            RecordController.setOtherBedrooms('');
            RecordController.setIsActive(true);
            for (let i = 0; i < element.length; i++) {
                if(element[i].classList.contains('next')){element[i].classList.remove('next')}
                element[i].classList.add('back')
            }
        }
        axios({
            method: 'post',
            url: LastPageVisited,
            params: {estimate_key: Elink, last_visited_page: last_visit_page}
        });
        AnimationPrevious ( "back-go",  "bedroom-page",  last_visit_page, PageView);
        RecordController.setAddManual(false);
        RecordController.SetClick('back');
    }

    const ActiveNextButton = (id) =>{ // this component is used to active clicked button for bedrooms
        let btn_id = parseInt(id)
        if (id === 'otherRooms' || btn_id > 5){
            setActiveButton('otherRooms'); // greater than 5 means, bedrooms entered manually
        }
        else if (btn_id === 1){
            setActiveButton('one')
        }
        else if (btn_id === 2){
            setActiveButton('two')
        }
        else if (btn_id === 3){
            setActiveButton('three')
        }
        else if (btn_id === 4){
            setActiveButton('four')
        }
        else if (btn_id === 5){
            setActiveButton('five')
        }
        btn_id !== 0 ? RecordController.setIsActive(true) : RecordController.setIsActive(false)
        id === 'otherRooms' ? RecordController.setOtherBedrooms('') : RecordController.setOtherBedrooms(btn_id)
    }

    const updateKeyBoard =  async (device_type) =>{ // component is used to show the keyboard on desktop
        setKeyboard(true);
        RecordController.setCustomItemModal(device_type === "desktop-vw" ? true : false)
        setShowKeyPad(device_type === "desktop-vw" ? false : !ShowKeyPad)
        const modalBackdrops = await document.getElementsByClassName('modal-backdrop');
        if (modalBackdrops[0] !== "" && modalBackdrops[0] !== undefined ) {
            if (modalBackdrops.length >1){
                modalBackdrops[1].classList.remove('modal-backdrop')
            }
            modalBackdrops[0].classList.remove('modal-backdrop')
        }
    }

    const handleModal = () =>{ // hide custom modals
        RecordController.setAlertBox(false)
        RecordController.setCustomItemModal(false)
    }
    const handleKeyPad = () =>{ // hide keypad
        RecordController.setAlertBox(false)
        setShowKeyPad( false);
    }

    const SecondPageContent = (device_type) => {
        return (
            <>
                <Modal className="alert-modal" show={!JobIsOpen || RecordController.ML_Start.InventoryType } onHide={JobIsOpen || !RecordController.ML_Start.InventoryType } id ="keypadModal"
                       style={{borderRadius: "30px",marginTop: "18%"}}>
                    <Modal.Body style={{height:"250px",textAlign: "center"}}> <b style={{fontSize: "115%"}}>
                        <img id="start-img" src={process.env.PUBLIC_URL + "/Images/alert.png"} alt="image" style={{height:"25%"}}/><br/><br/>
                        {
                            RecordController.ML_Start.InventoryType && JobIsOpen ? "This link is not valid for percentage inventory" :
                                "This job is currently booked, please contact your moving company to make any edits."
                        }
                    </b></Modal.Body>
                </Modal>
                <div className="container ">
                    <div className="row d-flex justify-content-center align-items-center" id="second-page-content">
                        <div className="col-sm-12 col-md-8 col-lg-6 col-xl-5">
                            <div className="card-st text-center">
                                <div className="logo text-center" style={{paddingTop: "7%",paddingBottom: "4%"}}>
                                    <div className="arrow" >
                                        <i className="fa fa-angle-left" style={{cursor: "pointer", color: GetTextColor(CustomerInvReq.BackgroundColor) }} onClick={(e)=> BackStep(e)}></i>
                                    </div>
                                    <div className="logo-image-desktop-2">
                                        <img src={RecordController.ML_Start.CompanyLogo ? RecordController.ML_Start.CompanyLogo :
                                            process.env.PUBLIC_URL + "/Images/mobileLinkLogo.png"} alt="image"/>
                                    </div>
                                    <div className="skip">
                                        <a href="#main" onClick={() => ShowSecondStep('skip')} style={{color: GetTextColor(CustomerInvReq.BackgroundColor)}}>SKIP</a>
                                    </div>
                                </div>
                                <div className="text-st-second">
                                    <div className="heading-text" style={{color: GetTextColor(CustomerInvReq.BackgroundColor), lineHeight: "initial"}}>
                                        {CustomerInvReq.EditVerbiage.default === "false" ? <b>{CustomerInvReq.EditVerbiage.bedroom_page_heading}</b> : <b>How many bedrooms do you have to move?</b>}
                                    </div>
                                    {
                                        DefaultRoomName ? (CustomerInvReq.EditVerbiage.default === "false" ?
                                            <p className="text-white-p" style={{color: GetTextColor(CustomerInvReq.BackgroundColor)}}>{CustomerInvReq.EditVerbiage.bedroom_page_subtitle}</p> :
                                            <p className="text-white-p" style={{color: GetTextColor(CustomerInvReq.BackgroundColor)}}>We've already included your<br/>
                                                {DefaultRoomName.replace(',',', ')}.</p>) : ""
                                    }
                                </div>
                                {RecordController.addManual  ?
                                    <div className={"align-center"} style={{width: "90%", margin: "auto"}}>
                                        <input className="form-control form-input key-pad-val"
                                               pattern="[0-9]*" id="key-pad-val"
                                               onChange={(e) => updateKeyBoard(device_type)}
                                               value={ RecordController.OtherBedrooms }
                                               onClick={(event) => updateKeyBoard(device_type)} />
                                        {RecordController.AlertBox === true ?
                                            <span style={{color: "red"}} id="alert-mess">
                                                Due to the large number of rooms, please contact your company to input inventory
                                            </span>
                                            : <></>}

                                    </div>
                                    :
                                    <div className="multiple-btn mb-5">
                                        <a className={"btn list-btn"} id={1} onClick={(event) => ActiveNextButton(event.target.id)}
                                           style={ActiveButton === "one" ? {backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)} : {}}>One</a>
                                        <a className={"btn list-btn"} id={2} onClick={(event) => ActiveNextButton(event.target.id)}
                                           style={ActiveButton === "two" ? {backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)} : {}}>Two</a>
                                        <a className={"btn list-btn"} id={3} onClick={(event) => ActiveNextButton(event.target.id)}
                                           style={ActiveButton === "three" ? {backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)} : {}}>Three</a>
                                        <a className={"btn list-btn"} id={4} onClick={(event) => ActiveNextButton(event.target.id)}
                                           style={ActiveButton === "four" ? {backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)} : {}}>Four</a>
                                        <a className={"btn list-btn"} id={5} onClick={(event) => ActiveNextButton(event.target.id)}
                                           style={ActiveButton === "five" ? {backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)} : {}}>Five</a>
                                        <a className={"btn list-btn"} id="otherRooms" onClick={(event) => ActiveNextButton(event.target.id)}
                                           style={ActiveButton === "otherRooms" ? {backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)} : {}}>Other</a>
                                    </div>
                                }
                            </div>
                        </div>
                        {Keyboard ?
                            <>
                                <Modal className="master-link" show={RecordController.CustomItemModal}
                                       onHide={()=>handleModal() } id ="keypadModal">
                                    <Modal.Body style={{backgroundColor: "whitesmoke", padding: 0}}> <KeypadModal /> </Modal.Body>
                                </Modal>
                            </>: <></>}
                        <button className={RecordController.isActive ? 'btn btn-st keypad-next desktop-vw' : 'btn btn-st-white keypad-next disabled desktop-vw'}
                                onClick={(event) => {RecordController.isActive ? ShowSecondStep('next') : ShowSecondStep('no_next')}}
                                style={RecordController.isActive ? {backgroundColor: CustomerInvReq.ButtonColor,color: GetTextColor(CustomerInvReq.ButtonColor)}: {}}>
                            <b>NEXT</b></button>
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            <section className="gradient-custom desktop-vw" style={{background: CustomerInvReq.BackgroundColor}} >
                <div className={"bedroom-page h-100"} style={{width: "100vw"}}>
                    {SecondPageContent("desktop-vw")}
                </div>
            </section>
            <section className= {ShowKeyPad || (ActiveButton === "otherRooms" && RecordController.addManual ) ? "mobile-section-keypad mobile-vw": "mobile-section-2 mobile-vw"  }
                     onClick={()=> ShowKeyPad === true ? handleKeyPad() : ""} style={{background: CustomerInvReq.BackgroundColor}}>
                <svg id="curve" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1416.99 174.01">
                    <path className="curve-path" d="M0,280.8S283.66,59,608.94,163.56s437.93,150.57,808,10.34V309.54H0V280.8Z"
                        transform="translate(0-135.53)" style={{position:"relative"}} fill="#f2f5f8"/>
                    <path className="curve-path"
                        d="M77.8,230.3S283.66,353,880.94,275.58s937.93,190.57,920,10.34V309.54H0V280.8Z"
                        transform="translate(0-135.53)" style={{position:"relative"}} fill="white"/>
                </svg>
                <div className={"bedroom-page"} style={{width: "100vw", height: "75%"}}>
                    {SecondPageContent("mobile-vw")}
                </div>
            </section>
            {/* this is making separate button and keypad for mobile devices*/}
            <div className="mobile-vw" style={{height: "18vh"}}>
                { ShowKeyPad ?
                    <>
                        <div className={"keypad-modal"} style={{backgroundColor: "whitesmoke", position: "fixed"}}> <KeypadModal/> </div>
                    </>
                    :
                    <>
                        <div id="second-div" style={{paddingTop: "8.75%"}}>
                            <button className={RecordController.isActive ? 'btn btn-st start-mobile-view-2 mobile-vw' :
                                'btn btn-st-white disabled start-mobile-view-2 mobile-vw'}
                                    style={{backgroundColor: RecordController.isActive ? CustomerInvReq.ButtonColor : '', color: RecordController.isActive ? GetTextColor(CustomerInvReq.ButtonColor) : '',
                                        position:"relative", width: "80%", marginBottom: "1%"}}
                                    onClick={(event) => {RecordController.isActive ? ShowSecondStep('next') : ShowSecondStep('no_next')}}><b>NEXT</b></button>
                        </div>
                    </>
                }
            </div>
        </>
    )
}
